<ppl-accordion [title]="'Current Authorizations'" [isOpen]="true" *authorize="[pageId, tabId, 'Authorization', 'section']">
    @if(this.entry === 'participantEnrollment'){
    <div class="table-style">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="!readOnly" [data]="approvedCurrentData"
            [disableSelection]="true" [cols]="approvedCols" (gridAction)="action($event)" [gridTitle]="false"
            [pagination]="false" [loadPage]="true" [actionButtons]="actionButtonsApproved">
        </ppl-list-table>
    </div>
    }@else {
    <ul class="paystub-list">
        <li class="paystub-item">
            <div>
                <div class="paystub-date">September 20, 2024</div>
                <div class="paystub-amount">$1,200.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">August 20, 2024</div>
                <div class="paystub-amount">$1,150.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">July 20, 2024</div>
                <div class="paystub-amount">$1,175.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">June 20, 2024</div>
                <div class="paystub-amount">$1,125.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
    </ul>
    }
</ppl-accordion>
<ppl-accordion [title]="'Auth Allocation by Personal Assistant'" [isOpen]="true"
    *authorize="[pageId, tabId, 'AuthAllocationByPA', 'section']">
    @if(mode==='read' )
    {
        @if(viewActions){
            <div class="custom-row">
                <div class="mr-2">
                    <ppl-button label="Add" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'"
                        (click)="addWeeklyLimit()"></ppl-button>
                </div>
            </div>
        }
    <div class="table-style">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="!readOnly" [data]="weeklyLimitData"
            [disableSelection]="true" [cols]="weeklyLimitCols" (gridAction)="action($event)" [gridTitle]="false"
            [pagination]="false" [loadPage]="true">
        </ppl-list-table>
    </div>
    }
    @else {
    <ppl-auth-allocation (cancel)="cancel($event)" [mode]="mode" [authData]="authData"
        (savedWeeklyLimit)="savedWeeklyLimit($event)"></ppl-auth-allocation>
    }

</ppl-accordion>
<ppl-accordion [title]="'Upcoming Authorizations'" [isOpen]="false"
    *authorize="[pageId, tabId, 'Authorization', 'section']">
    @if(this.entry === 'participantEnrollment'){
    <div class="table-style">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="!readOnly" [data]="approvedUpcomingData"
            [disableSelection]="true" [cols]="approvedCols" (gridAction)="action($event)" [gridTitle]="false"
            [pagination]="false" [loadPage]="true" [actionButtons]="actionButtonsApproved">
        </ppl-list-table>
    </div>
    }@else {
   
    }
</ppl-accordion>
<ppl-accordion [title]="'Past Authorizations'" [isOpen]="false" *authorize="[pageId, tabId, 'Authorization', 'section']">
    @if(this.entry === 'participantEnrollment'){
    <div class="table-style">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="!readOnly" [data]="approvedPastData"
            [disableSelection]="true" [cols]="approvedCols" (gridAction)="action($event)" [gridTitle]="false"
            [pagination]="false" [loadPage]="true" [actionButtons]="actionButtonsApproved">
        </ppl-list-table>
    </div>
    }@else {
  }
</ppl-accordion>
<ppl-accordion [title]="'Errored Out Authorizations'" [isOpen]="false" *authorize="[pageId, tabId, 'Authorization', 'section']">

    @if(this.entry === 'participantEnrollment'){
    <div class="table-style">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="!readOnly" [data]="erroredOutData"
            [disableSelection]="true" [cols]="erroredCols" (gridAction)="action($event)" [gridTitle]="false"
            [pagination]="false" [loadPage]="true" [actionButtons]="actionButtonsErrored">
        </ppl-list-table>
    </div>
    }@else {
    <ul class="paystub-list">
        <li class="paystub-item">
            <div>
                <div class="paystub-date">September 20, 2024</div>
                <div class="paystub-amount">$1,200.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">August 20, 2024</div>
                <div class="paystub-amount">$1,150.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">July 20, 2024</div>
                <div class="paystub-amount">$1,175.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">June 20, 2024</div>
                <div class="paystub-amount">$1,125.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
    </ul>
    }
</ppl-accordion>
<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
       <ppl-authorization-details [pageSource]="pageSource"></ppl-authorization-details>
    </ng-template>
</div>
<div class="filter-panel">
    <ng-template #historyDialog let-cancel="cancel">
      @if(historyData?.length > 0){
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="historyData"
        [disableSelection]="true" [cols]="historyCols" [gridTitle]="false" [pagination]="true" [loadPage]="false">
    </ppl-list-table>
      }
      @else {
        No Data Available
      }
    </ng-template>
</div>